import "./LovableToast.scss";

let hideTimeoutId = null;
let removeTimeoutId = null;

const ZENDESK_LAUNCHER_SELECTORS = [
  "#launcher",
  'iframe[title*="Messaging"]',
  'iframe[title*="launch"]',
  '[class*="zEWidget-launcher"]',
];

/** Keep toast above the Zendesk support launcher (bottom-right). */
const getToastBottomOffset = () => {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return 96;
  }

  for (const selector of ZENDESK_LAUNCHER_SELECTORS) {
    const el = document.querySelector(selector);
    if (!el) continue;

    const rect = el.getBoundingClientRect();
    if (rect.width > 0 && rect.height > 0) {
      return Math.ceil(window.innerHeight - rect.top + 12);
    }
  }

  return 96;
};

/** Lovable / Sonner-style toast — dark glass card, bottom-right. */
export const showLovableToast = (message = "") => {
  if (typeof document === "undefined" || !message) return;

  const existing = document.querySelector(".lovable-toast");
  if (existing) existing.remove();

  if (hideTimeoutId) clearTimeout(hideTimeoutId);
  if (removeTimeoutId) clearTimeout(removeTimeoutId);

  const toast = document.createElement("div");
  toast.className = "lovable-toast";
  toast.setAttribute("role", "status");
  toast.textContent = message;
  toast.style.bottom = `${getToastBottomOffset()}px`;
  document.body.appendChild(toast);

  requestAnimationFrame(() => {
    toast.classList.add("lovable-toast--visible");
  });

  hideTimeoutId = window.setTimeout(() => {
    toast.classList.remove("lovable-toast--visible");
    removeTimeoutId = window.setTimeout(() => {
      toast.remove();
    }, 400);
  }, 4000);
};
